export default __webpack_public_path__ + "static/media/ecovadis.8e0273e7.png";